import type { TypographyVariantsOptions } from '@mui/material/styles';

export const typography: TypographyVariantsOptions = {
  fontFamily: '"Inter", sans-serif',

  // ─── Display ───────────────────────────────────────────────────────────────

  // Display 2xl — 72px / 90px / -2%
  h1: {
    fontSize: '4.5rem',
    lineHeight: '5.625rem',
    letterSpacing: '-0.02em',
    fontWeight: 400,
  },

  // Display xl — 60px / 72px / -2%
  h2: {
    fontSize: '3.75rem',
    lineHeight: '4.5rem',
    letterSpacing: '-0.02em',
    fontWeight: 400,
  },

  // Display lg — 48px / 60px / -2%
  h3: {
    fontSize: '3rem',
    lineHeight: '3.75rem',
    letterSpacing: '-0.02em',
    fontWeight: 400,
  },

  // Display md — 36px / 44px / -2%
  h4: {
    fontSize: '2.25rem',
    lineHeight: '2.75rem',
    letterSpacing: '-0.02em',
    fontWeight: 400,
  },

  // Display sm — 30px / 38px
  h5: {
    fontSize: '1.875rem',
    lineHeight: '2.375rem',
    letterSpacing: '0',
    fontWeight: 400,
  },

  // Display xs — 24px / 32px
  h6: {
    fontSize: '1.5rem',
    lineHeight: '2rem',
    letterSpacing: '0',
    fontWeight: 400,
  },

  // ─── Text ──────────────────────────────────────────────────────────────────

  // Text xl — 20px / 30px
  subtitle1: {
    fontSize: '1.25rem',
    lineHeight: '1.875rem',
    letterSpacing: '0',
    fontWeight: 400,
  },

  // Text lg — 18px / 28px
  subtitle2: {
    fontSize: '1.125rem',
    lineHeight: '1.75rem',
    letterSpacing: '0',
    fontWeight: 400,
  },

  // Text md — 16px / 24px
  body1: {
    fontSize: '1rem',
    lineHeight: '1.5rem',
    letterSpacing: '0',
    fontWeight: 400,
  },

  // Text sm — 14px / 20px
  body2: {
    fontSize: '0.875rem',
    lineHeight: '1.25rem',
    letterSpacing: '0',
    fontWeight: 400,
  },

  // Text xs — 12px / 18px
  caption: {
    fontSize: '0.75rem',
    lineHeight: '1.125rem',
    letterSpacing: '0',
    fontWeight: 400,
  },
};
